<template>
    <div v-show="isModalVisible">
        <transition name="slide">
            <div class="modal-mask" @click="hide">
                <div class="modal-dialog modal-dialog-slideout modal-lg"  @click.stop>
                   <div class="modal-content  p-2">

                        <div class="modal-header">
                             <a href="javascript:void(0);" @click="hide" style="cursor: pointer;" class="text-uppercase text-muted pt-1"><img class="back_icon mr-2" src="@/assets/manager/back_button_icon.png" />Back</a>
                                <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="hide">
                                    <span aria-hidden="true">×</span>
                                </button>          
                        </div>                
                        
                        <div class="modal-body">
                          <div class="maheading_2">
                                <h5 class="modal-title">New Payment Method</h5>
                          </div>  
                          <div class="maheading_2">
                              New payment methods do not automatically pay for your subscriptions. After you add a new one, assign it as your primary payment method.
                          </div>  

                    <b-alert
                      :show="dismissCountWarningDown"
                      dismissible
                      variant="danger"
                      @dismissed="dismissCountWarningDown=0"
                      @dismiss-count-down="countDownWarningChanged"
                      >
                      {{ warning_message }}
                    </b-alert>


                        <div class="row mt-4" >
                          <div class="col-12">
                            <label class="form-label">Credit/Debit Card Information</label>
                              <div class="row">
                                <div class="col-sm-12 col-md-12">
                                  <div class="row">
                                    <div class="col-sm-12 col-md-12">
                                      <input 
                                          type="text" 
                                          class="col-12 col-sm-12 input-height-35 form-control" 
                                          name="card_no" 
                                          v-model="cardNumber" 
                                          v-validate="'required|numeric'"
                                          placeholder="Credit Number">
                                          <div v-if="verrors.firstByRule('card_no', 'required')" class="margin-bottom-5 validate-warning-msg">Card Number is required</div>
                                          <div v-if="verrors.firstByRule('card_no', 'numeric')" class="margin-bottom-5 validate-warning-msg">Card Number must contain numeric characters only</div>
                                        </div>
                                      </div>
                                      <div class="row mt-2">
                                        <div class="col-sm-12 col-md-12">
                                          <input 
                                            type="text" 
                                            class="col-12 col-sm-12 input-height-35 form-control" 
                                            name="name_on_card" 
                                            v-model="nameOnCard" 
                                            v-validate="'required'"
                                            placeholder="Name on Card">
                                            <div v-if="verrors.firstByRule('name_on_card', 'required')" class="margin-bottom-5 validate-warning-msg">Name on Card is required</div>
                                        </div>
                                      </div>
                                      <div class="row mt-2">
                                        <div class="col-6 col-sm-6">
                                          <select 
                                            class="col-12 col-sm-12 input-height-35 form-control" 
                                            name="exp_month" 
                                            v-model="expMonth" 
                                            v-validate="'required'">
                                            <option value="">Month</option>
                                            <option value="01">01</option>
                                            <option value="02">02</option>
                                            <option value="03">03</option>
                                            <option value="04">04</option>
                                            <option value="05">05</option>
                                            <option value="06">06</option>
                                            <option value="07">07</option>
                                            <option value="08">08</option>
                                            <option value="09">09</option>
                                            <option value="10">10</option>
                                            <option value="11">11</option>
                                            <option value="12">12</option>
                                          </select>
                                          <div v-if="verrors.firstByRule('exp_month', 'required')" class="margin-bottom-5 validate-warning-msg">Month is required</div>
                                        </div>
                                        <div class="col-6 col-sm-6">
                                          <b-form-select
                                              class="col-12 col-sm-12 input-height-35 form-control"
                                              name="exp_year" 
                                              v-model="expYear" 
                                              v-validate="'required'"
                                              :options="year_options">
                                          </b-form-select>
                                          <div v-if="verrors.firstByRule('exp_year', 'required')" class="margin-bottom-5 validate-warning-msg">Year is required</div>   
                                        </div>
                                      </div>
                                    </div>
                                </div>
                            </div>
                        </div>




                          <div class="row pt-4">
                              <div class="col-12">
                                <label class="form-label">Billing Information</label>
                                <div class="row mt-3">
                                  <div class="col-12 col-sm-12">      
                                      <input
                                        type="text"
                                        id="bname"
                                        class="col-12 col-sm-12 input-height-35 form-control"
                                        ref="bname"
                                        name="bname"
                                        v-model="billingName"
                                        v-validate="{ rules: { required: true, regex: billingNameRegex() } }"
                                        placeholder="Billing Name"
                                        maxlength="250"
                                        autocomplete="off">
                                      <div v-if="verrors.firstByRule('bname', 'required')" class="margin-bottom-5 validate-warning-msg">Billing name is required</div>
                                      <div v-if="verrors.firstByRule('bname', 'regex')" class="margin-bottom-5 validate-warning-msg">Billing name should only contain - and _</div>
                                    </div>
                                  </div>
                                  <div class="row mt-2">
                                    <div class="col-12 col-sm-12">
                                      <b-form-select
                                      class="col-12 col-sm-12 input-height-35 form-control"
                                      id="country_id" v-model="billingCountry" v-validate="'required'" name="billing_country"
                                      :options="country_options"
                                      v-on:change="getStateLists(billingCountry)">
                                      </b-form-select>
                                      <div v-if="verrors.firstByRule('billing_country', 'required')" class="margin-bottom-5 validate-warning-msg">Country is required</div>
                                    </div>
                                    <div class="col-12 col-sm-12 mt-2">
                                      <input 
                                          type="text" 
                                          class="col-12 col-sm-12 input-height-35 form-control" 
                                          name="billing_address_1" 
                                          placeholder="Billing Address 1" 
                                          v-model="billingAddress" 
                                          v-validate="'required'"
                                          maxlength="250">
                                      <div v-if="verrors.firstByRule('billing_address_1', 'required')" class="margin-bottom-5 validate-warning-msg">Billing Address 1 is required</div>
                                    </div>                 
                                    <div class="col-12 col-sm-12 mt-2">
                                      <input 
                                          type="text" 
                                          class="col-12 col-sm-12 input-height-35 form-control" 
                                          name="billing_address_2" 
                                          placeholder="Billing Address 2" 
                                          v-model="billingAddress2"
                                          maxlength="250" 
                                          >
                                    </div>                                                       
                                    <div class="col-12 col-sm-12 mt-2">
                                      <input 
                                      type="text" 
                                      name="phone number" 
                                      id="phone_number"
                                      ref="phone_number"
                                      v-validate="{ rules: { regex: phoneRegex(), required: true } }"
                                      v-model="billingPhone"
                                      @keyup="billingPhoneValid"
                                      @blur="billingPhoneValid"
                                      class="col-12 col-sm-12 input-height-35 form-control" 
                                      placeholder="Phone Number"
                                      >
                                      <div v-show="verrors.has('phone number')" class="validate-warning-msg">{{ verrors.first('phone number') }}</div>
                                    </div>
                                  </div>
                                  <div class="row mt-2">
                                    <div class="col-4 col-sm-4">
                                        <input 
                                            type="text" 
                                            class="col-12 col-sm-12 input-height-35 form-control" 
                                            name="billing_city" 
                                            placeholder="City" 
                                            v-model="billingCity" 
                                            v-validate="'required'"
                                            maxlength="150">
                                        <div v-if="verrors.firstByRule('billing_city', 'required')" class="margin-bottom-5 validate-warning-msg">City is required</div>
                                    </div>
                                    <div class="col-4 col-sm-4">
                                      <b-form-select
                                      class="col-12 col-sm-12 input-height-35 form-control"
                                      name="billing_state" v-model="billingState" v-validate="'required'"
                                      :options="state_options">
                                      </b-form-select>    
                                      <div v-if="verrors.firstByRule('billing_state', 'required')" class="margin-bottom-5 validate-warning-msg">State is required</div>
                                    </div>
                                    <div class="col-4 col-sm-4">
                                      <input 
                                      type="text" 
                                      name="zip code" 
                                      id="org_zip"
                                      ref="org_zip"
                                      v-validate="{ rules: { regex: getPostalCodeRegex(), required: true } }"
                                      v-model="billingZip"
                                      maxlength="10"
                                      class="col-12 col-sm-12 input-height-35 form-control" 
                                      placeholder="Zip">
                                      <div v-show="verrors.has('zip code')" class="validate-warning-msg">{{ verrors.first('zip code') }}</div>
                                    </div>
                                  </div>
                              </div>
                          </div>



                          <div class="text-center m-4">
                              <button :disabled="process_payment_disable" type="button" class="btn btn-md ma-blue-btn" @click="onSubmit">
                                  Save
                              </button>
                          </div>





                        </div>
                        <div class="modal-footer"></div>
                    </div>
                </div>
            </div>
        </transition>

    </div>
  </div>

</template>
<script>
import Vue from 'vue/dist/vue.esm';
import router from '../../router/index.js';
import axios from 'axios';
import VeeValidate from 'vee-validate';
import moment from 'moment';
import { BPopover } from 'bootstrap-vue'
Vue.component('b-popover', BPopover)



Vue.filter('formatExpirationDate', function(value) {
  if (value) {
    return moment(String(value)).format('MMMM DD, YYYY')
  }
});

Vue.use(VeeValidate, { errorBagName: 'verrors', fieldsBagName: 'vfields'});

export default {
    props: ['isModalVisible'],
    data() {
        return {
            loading: false,
            billingName: '',
            billingAddress: '',
            billingAddress2: '',
            billingCity: '',
            billingState: '',
            billingCountry: '',
            billingZip: '',
            billingPhone: '',
            nameOnCard: '',
            cardNumber: '',
            expMonth: '',
            expYear: '',
            cvvValue: '',
            year_options: [],
            process_payment_disable: false,
            dismissCountWarningDown: 0,
            warning_message: '',
            country_options: [],
            state_options: [],
        }
    },
    components: {
    },
    methods: {       
        hide() { 
            this.verrors.clear();
            this.$emit('close');
        },
        countDownWarningChanged(dismissCountWarningDown) {
          this.dismissCountWarningDown = dismissCountWarningDown
        },
        onSubmit() {
          this.$validator.validateAll().then((result) => {
              if (this.verrors.items.length === 0) {
                  this.processPayment();
              }
          });
        },
        processPayment() {
          this.process_payment_disable = true;
          this.loading = true;
          axios('/new-payment-method', 
          {
              method: 'POST',
              data: {
                "account_id": this.$store.state.user_accountid,
                "billing_name": this.billingName,
                "billing_address": this.billingAddress,
                "billing_address2": this.billingAddress2,
                "billing_city": this.billingCity,
                "billing_state": this.billingState,
                "billing_country": this.billingCountry,
                "billing_zip": this.billingZip,
                "billing_phone": this.billingPhone,
                "payment_method": this.paymentMethod,
                "name_oncard": this.nameOnCard,
                "card_number": this.cardNumber,
                "exp_month": this.expMonth,
                "exp_year": this.expYear.toString().substr(-2),
                "cvv_value": this.cvvValue,
              },
          })
          .then((response) => {
              this.process_payment_disable = false;
              if (response.data.msg != 'failed') {
                this.billingName = '';
                this.billingAddress = '';
                this.billingAddress2 = '';
                this.billingCity = '';
                this.billingState = '';
                this.billingCountry = '';
                this.billingZip = '';
                this.billingPhone = '';
                this.nameOnCard = '';
                this.cardNumber = '';
                this.expMonth = '';
                this.expYear = '';
                this.cvvValue = '';
                this.$parent.closePaymentMethod();
                this.verrors.clear();
              }
              else {
                this.warning_message = 'This card is not authorized by bank!';
                this.dismissCountWarningDown = 10;
              }
              
          })
          .catch(error => {
              this.process_payment_disable = false;
              console.log(error)
          });
        },

        billingNameRegex() {
            return /^[a-zA-Z-_ ']*$/;
        },
        billingPhoneValid() {
            var billing_phone = this.billingPhone;
            this.billingPhone = billing_phone.replace(/[^0-9]/g, '').replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3');
        },
        phoneRegex() {
            return /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
        },
        getPostalCodeRegex() {
            return /^[0-9]{5}(?:-[0-9]{4})?$/;
        },
        getCountryLists() {
            axios.get('/get-country-lists', {

            })
            .then(response =>  {
                this.country_options = response.data;
            })
            .catch(function(error) {

            });
        },
        getStateLists(CountryCode) {
            axios.get('/get-state-lists/' + CountryCode, {

            })
            .then(response =>  {
                this.state_options = response.data;
            })
            .catch(function(error) {

            });
        },
        getExpiryYears() {
            this.year_options = [
                { value: '', text: 'Year' },
            ];       
            var min = new Date().getFullYear()
            var max = min + 20;
            for (var i = min; i <= max; i++) {
                var yoptions = { value: i, text: i };
                this.year_options.push(yoptions);
            }
        },
        loadInitialData() {
          this.verrors.clear();
          this.getExpiryYears();
          this.getCountryLists();
        },  
    },
    created() {

    }   
}
</script>
<style scoped>
.back_icon { width: 14px; }
::-webkit-scrollbar {
    width: 0;  /* Remove scrollbar space */
    background: transparent;  /* Optional: just make scrollbar invisible */
}
.modal-mask {
    position: fixed;
    z-index: 1001;
    top: 59px;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, .5);
    transition: opacity .3s ease;
    overflow-y: scroll;
}
.modal-dialog {
  animation: slide-in 1s forwards;
  -webkit-animation: slide-in 1s forwards;
}

@keyframes slide-in {
  0% {
    -webkit-transform: translateX(100%);
  }
  100% {
    -webkit-transform: translateX(0%);
  }
}

@-webkit-keyframes slide-in {
  0% {
    transform: translateX(100%);
  }
  100% {
    transform: translateX(0%);
  }
}
.modal-dialog {
  max-width: 90%;
}
@media (min-width: 992px) {
    .modal-lg, .modal-xl { width: 700px; }
}
@media (max-width: 576px){ 
    .modal-dialog.modal-dialog-slideout { width: 80% }
}
.modal-dialog-slideout {
    min-height: 100%; margin: 0 0 0 auto; background: #fff; 
}
.modal-dialog-slideout .modal-content{ border: 0; }
.modal-header { border-bottom: none; }
.modal-footer { border-top: none; }
.modal-goback { font-size: 24px; margin: 5px 10px 0 0; cursor: pointer; }
.modal-title { font-weight: 900; }
.modal-body { padding: 0rem 1.5rem 0rem 1.5rem; overflow: auto;}
.maheading_1 { width: 5%; }
.maheading_2 { width: 75%; }
.maheading_3 { width: 20%; }
.rounded {
    border-radius: 10px !important;
    padding: 20px;
    border: 1px solid #B8B7B8;
}
.seat_qty {
    font-size: 13px;
}
.ma-blue-btn, .ma-blue-btn:hover, .ma-blue-btn:focus {
  color: #FFF !important; 
  border-radius: 15px;
  background-color: #00acee !important;
  border: 1px solid #00acee !important;
  font-weight: 900;
  padding: 5px 20px;
}
input, select {
    line-height: 17px;
    border-radius: 10px;
    padding-left: 5px !important;
    border: 1px solid #707070;
}
</style>




// WEBPACK FOOTER //
// src/components/manager/new_payment_method.vue